/**
 * FavoritesPage.jsx
 *
 * Page des cartes favorites avec Ant Design
 */

import React, { useEffect, useState } from "react";
import { getFavorites } from "../api/api";
import { useAuth } from "../context/AuthContext";
import CardGrid from "../components/Cards/CardGrid";
import { Spin, message } from "antd";
import { useTheme } from "../context/ThemeContext";

/**
 * FavoritesPage - Cartes favorites de l'utilisateur
 */
export default function FavoritesPage() {
    const { token, logout } = useAuth();
    const { isDarkMode } = useTheme();
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                setLoading(true);
                const res = await getFavorites();
                setCards(res.data);
            } catch (err) {
                if (err.response?.status === 401) {
                    message.error("Session expirée");
                    logout();
                } else {
                    message.error("Erreur chargement favoris");
                }
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            fetchFavorites();
        }
    }, [token]);

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "48px" }}>
                <Spin />
            </div>
        );
    }

    return (
        <div style={{ padding: "24px", minHeight: "100vh", background: isDarkMode ? "#000000" : "#fafafa" }}>
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "16px" }}>
                    Mes cartes favorites
                </h2>
                <CardGrid cards={cards} />
            </div>
        </div>
    );
}